// =============================================================
// NAV — primary, sticky
// =============================================================

import { useEffect, useId, useState } from "react";
import { COPY } from "@/features/landing/content/landing-copy";
import styles from "./Nav.module.css";

interface RootProps {
  children?: never;
}

function Root(_props: RootProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const menuId = useId();

  useEffect(() => {
    if (!isMenuOpen) return;

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") setIsMenuOpen(false);
    };

    window.addEventListener("keydown", closeOnEscape);
    return () => window.removeEventListener("keydown", closeOnEscape);
  }, [isMenuOpen]);

  const closeMenu = () => setIsMenuOpen(false);

  return (
    <header className={styles.nav} role="banner">
      <div className={styles["nav__inner"]}>
        <a href="#safak" className={styles["nav__brand"]} aria-label="Fuar Cafe Catering — ana sayfa">
          <img
            className={styles["nav__brand-logo"]}
            src="/img/logo.png"
            alt=""
            width={816}
            height={428}
            decoding="async"
          />
        </a>

        <nav aria-label="Birincil gezinme" className={styles["nav__list"]}>
          {COPY.nav.map((item) => (
            <a key={item.href} href={item.href}>{item.label}</a>
          ))}
        </nav>

        <div className={styles["nav__actions"]}>
          <a
            href="tel:+905324403696"
            className={styles["nav__cta"]}
            aria-label="Telefonla ara: 0532 440 36 96"
          >
            <svg
              className={styles["nav__phone-icon"]}
              viewBox="0 0 24 24"
              fill="currentColor"
              aria-hidden="true"
            >
              <path d="M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2a15.05 15.05 0 0 1-6.59-6.58l2.2-2.21a1 1 0 0 0 .25-1.02A11.36 11.36 0 0 1 8.5 4a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1c0 9.39 7.61 17 17 17a1 1 0 0 0 1-1v-3.5a1 1 0 0 0-1-1z" />
            </svg>
            <span className={styles["nav__cta-label"]}>0532 440 36 96</span>
            <span className={styles["nav__cta-label-short"]}>Ara</span>
          </a>

          <button
            type="button"
            className={styles["nav__menu-toggle"]}
            aria-label={isMenuOpen ? "Menüyü kapat" : "Menüyü aç"}
            aria-expanded={isMenuOpen}
            aria-controls={menuId}
            onClick={() => setIsMenuOpen((open) => !open)}
          >
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </button>
        </div>
      </div>

      <nav
        id={menuId}
        className={styles["nav__mobile-panel"]}
        aria-label="Mobil gezinme"
        data-open={isMenuOpen ? "true" : "false"}
        hidden={!isMenuOpen}
      >
        <div className={styles["nav__mobile-list"]}>
          {COPY.nav.map((item) => (
            <a key={item.href} href={item.href} onClick={closeMenu}>{item.label}</a>
          ))}
          <a href="tel:+905324403696" onClick={closeMenu}>0532 440 36 96</a>
        </div>
      </nav>
    </header>
  );
}

export const Nav = { Root };
